import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import CommonHeadingNBtns from "../../common-components/CommonHeadingNBtns";
import { showConfirmAlert } from "../../components-react/ReactAlert";

const DPFDCreationForm = ({
  userInfoData,
  callFunction,
  closeModal,
  isFdEnable,
  modName,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);

  const isFdCreation = modName === "fd_creation";
  const StaffType = modName === "fd_creation" ? "FD" : "CM (Cluster Manager)";

  const forminitials = {
    requestLimit: isFdCreation
      ? isFdEnable?.fd_req_limit || ""
      : isFdEnable?.cm_req_limit || "",
    isActive: isFdCreation
      ? isFdEnable?.fd_is_enabled || false
      : isFdEnable?.cm_is_enabled || false,
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;

    setFormValues((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  function validationDPFDCreationForm(values) {
    const errors = {};

    if (formValues.isActive && !values.requestLimit) {
      errors.requestLimit = "Request Limit is required";
    } else if (Number(values.requestLimit) < 0) {
      errors.requestLimit = "Request Limit cannot be negative";
    }

    return errors;
  }

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = "/payment/discount_req_limit_toggle";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        callFunction();
        closeModal();
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = () => {
    const errors = validationDPFDCreationForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors)?.length === 0) {
      const userData = {
        fd_is_enabled: isFdCreation ? (formValues.isActive ? 1 : 0) : "",
        fd_req_limit: isFdCreation ? formValues.requestLimit || 0 : "",

        cm_is_enabled: isFdCreation ? "" : formValues.isActive ? 1 : 0,
        cm_req_limit: isFdCreation ? "" : formValues.requestLimit || 0,
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to ${
          formValues.isActive ? "enable" : "disable"
        } FD creation?`,
        "Edit Form",
        "Submit Form"
      );
    }
  };

  return (
    <>
      <CommonHeadingNBtns
        title={`${StaffType} Creation`}
        onClose={closeModal}
        btnTxt={"submit"}
        onClick={onSubmit}
        isLoading={postPutLoading}
      />

      <div className="info-tag">
        <span>
          This feature controls the number of discount payment requests that can
          be created by {StaffType}.
          <br />
          When disabled, {StaffType} can create unlimited discount payment
          requests.
          <br />
          When enabled, you must set a request limit. {StaffType} will not be
          able to create more discount payment requests than the specified
          limit.
          <br />
          If {StaffType} attempts to exceed the limit, an error will be shown.
        </span>
      </div>

      <form className="formContainer">
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label htmlFor="requestLimit" className={`formInputLabel `}>
              Request Limit <span className="required">*</span>
            </label>

            <input
              type="number"
              placeholder="Enter Request Limit"
              className={`formInput ${
                formErrors?.requestLimit ? "formError" : ""
              }`}
              name="requestLimit"
              value={formValues.requestLimit}
              onChange={onChangeInput}
              min={0}
            />
          </div>

          <div className="formInputBox span2">
            <div
              className={`commonWrapper commonSwitchWrapper no-border ${
                formErrors?.isActive ? "formError" : ""
              }`}
            >
              <Form.Check
                type="switch"
                name="isActive"
                label={`Enable FD Create Option`}
                className={`hygine-label ${
                  formValues.isActive ? "active" : ""
                }`}
                checked={formValues.isActive}
                onChange={onChangeInput}
              />
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default DPFDCreationForm;
